// extracted by mini-css-extract-plugin
export default {"titleUp":"dQYByEjY","valueTitle":"PSgGIr9_","sliderWrapper":"f5soFIDA"};